import React from 'react';
import { TestimonialCard } from './TestimonialCard';
import { testimonials, SHOW_TESTIMONIAL_PLACEHOLDER } from '../data/testimonials';
export function Testimonials() {
  if (testimonials.length === 0 && !SHOW_TESTIMONIAL_PLACEHOLDER) return null;
  return <section aria-label="Testimonials" className="bg-transparent" data-id="element-256" data-mp="3fxksu698nxhv">
      
    </section>;
}